import { extendTailwindMerge } from 'tailwind-merge';
import { fontSize, boxShadow } from '@figmotion/tailwind';

export const twMerge = extendTailwindMerge({
  classGroups: {
    'box-shadow-type': [{ shadow: Object.keys(boxShadow) }],
    'font-size': [{ text: Object.keys(fontSize) }],
  },
});
